import {__, transString} from '../../../support/lang/translations.ts';
import {useParams} from 'react-router-dom';
import {useAppSelector} from '../../../store/store.ts';
import {Status} from '../../../enums/status.ts';
import {CenteredSpinner} from '../../../components/spinner/centered_spinner.tsx';
import {Form} from '../../../components/form/form.tsx';
import {FormGrid} from '../../../components/form/form_grid.tsx';
import {PageTitle} from '../../../components/page/page_title.tsx';
import {PageContent} from '../../../components/page/page_content.tsx';
import {MileageHistory} from './../components/mileage_history.tsx';
import {MileageHistoryItem} from './../components/mileage_history_item.tsx';

export function Mileage() {
    const params = useParams<'vehicleId'>();
    const vehicleId = parseInt(params.vehicleId ?? '-1', 10);
    const customerInfo = useAppSelector((state) => state.customerInfo);
    const isLoading = customerInfo.status !== Status.FULFILLED;

    if (isLoading) {
        return <CenteredSpinner />;
    }

    const vehicle = customerInfo.me?.customer?.vehicles?.find((v) => v?.id === vehicleId);
    if (!vehicle) {
        return <div>404</div>;
    }

    const sortedMileageHistory =
        vehicle.mileageHistory
            ?.filter((mh) => mh?.mileage != null)
            .sort((a, b) => {
                if (a?.mileage != null && b?.mileage != null && a.mileage < b.mileage) return 1;
                if (a?.mileage != null && b?.mileage != null && a.mileage > b.mileage) return -1;
                return 0;
            })
            .map((obj) => obj) ?? [];

    return (
        <>
            <p className="leading">{__('vehicles.copy.mileage')}</p>

            <Form>
                <FormGrid>
                    <label>
                        {__('vehicles.fields.mileage')}
                        <input
                            defaultValue={vehicle?.mileage ?? '0'}
                            name="mileage"
                            type="number"
                            min={0}
                            max={999999999}
                            step={1}
                            required={true}
                            disabled={isLoading}
                            pattern="[0-9]"
                        />
                    </label>
                </FormGrid>
            </Form>

            <PageTitle>
                <h2>{__('vehicles.titles.mileage_history')}</h2>
            </PageTitle>

            {/*TODO: Get data from API*/}
            <PageContent>
                <MileageHistory>
                    {sortedMileageHistory != null && sortedMileageHistory.length !== 0 ? (
                        sortedMileageHistory.map((m, key) => (
                            <MileageHistoryItem
                                key={key}
                                label={transString('vehicles.labels.mileage_added')}
                                date={m?.date}
                                value={m?.mileage}
                            />
                        ))
                    ) : (
                        <>
                            <MileageHistoryItem label={transString('vehicles.labels.mileage_added')} />
                            <MileageHistoryItem label={transString('vehicles.labels.mileage_added')} />
                            <MileageHistoryItem label={transString('vehicles.labels.mileage_added')} />
                        </>
                    )}
                </MileageHistory>
            </PageContent>
        </>
    );
}
